import { useAppDispatch } from "../../../../redux/hooks";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../components/actionMenu/ActionMenu";
import { AwbHistoryDataInterface } from "../../../../redux/interfaces/expedition.interface";
import {
  fetchPrintAwbA4,
  fetchPrintAwbZebra,
} from "../../../../redux/api/expedition.api";
import { useNavigate } from "react-router-dom";
import { expeditionRoutes } from "../../../../router/routesConstants";
import useActiveExpeditionType from "../useActiveExpeditionType";

function AwbHistoryActionButtons({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: AwbHistoryDataInterface;
}) {
  const dispatch = useAppDispatch();
  const type = useActiveExpeditionType();
  const navigate = useNavigate();

  const handlePrintAwbA4 = () => {
    if (itemId) {
      dispatch(
        fetchPrintAwbA4({
          idDocTrans: itemId,
        }),
      );
    }
  };

  const handlePrintAwbZebra = () => {
    if (itemId) {
      dispatch(
        fetchPrintAwbZebra({
          idDocTrans: itemId,
        }),
      );
    }
  };

  const handleGetPackages = () => {
    if (itemId) {
      const params = new URLSearchParams({
        idExpeditie: itemId,
        client: crudData.client,
        type,
      });
      navigate(`${expeditionRoutes.activePackages}?${params}`);
    }
  };

  const items: ActionMenuItem[] = [
    {
      id: "active-packages",
      label: "Colete active",
      icon: "PACKAGES",
      tooltip: itemId
        ? "Afiseaza coletele active ale acestei expeditii."
        : "Expeditia trebuie sa aiba un identificator pentru a afisa coletele.",
      disabled: !itemId,
      onClick: handleGetPackages,
    },
    {
      id: "print-a4",
      label: "Print A4",
      icon: "DOCUMENTS",
      kind: "print",
      dividerBefore: true,
      tooltip: itemId
        ? "Deschide AWB-ul pentru imprimare A4."
        : "AWB-ul trebuie sa aiba un identificator pentru imprimare.",
      disabled: !itemId,
      onClick: handlePrintAwbA4,
    },
    {
      id: "print-zebra",
      label: "Print Zebra",
      icon: "LABEL",
      kind: "print",
      tooltip: itemId
        ? "Deschide AWB-ul pentru imprimanta Zebra."
        : "AWB-ul trebuie sa aiba un identificator pentru imprimare.",
      disabled: !itemId,
      onClick: handlePrintAwbZebra,
    },
  ];

  return (
    <ActionMenu
      items={items}
      title={`AWB ${crudData.doc_trans}`}
      ariaLabel={`Actiuni pentru AWB ${crudData.doc_trans}`}
    />
  );
}

export default AwbHistoryActionButtons;
